/**
 * Frontend re-exports of the shared formatters plus a small image-URL helper.
 * Keeping a thin local module means components import from one place.
 */
export { formatKES, formatNairobiDate } from '@skytech/shared';

const UPLOADS_ORIGIN = import.meta.env.VITE_UPLOADS_URL ?? '';

/**
 * Keep per-release invalidation until storage provides per-image versions (§7.6).
 * Removing this now would leave replaced assets stale under immutable caching.
 */
/** Maps a stored `/uploads/...` path to its browser URL (optional CDN origin) + version. */
function resolveUpload(path: string): string {
  const base =
    UPLOADS_ORIGIN && path.startsWith('/uploads')
      ? `${UPLOADS_ORIGIN}${path.slice('/uploads'.length)}`
      : path;
  return `${base}?r=${__APP_VERSION__}`;
}

/**
 * Resolves a stored ProductImage `path` (e.g. /uploads/products/{id}/) plus display
 * order + variant into a browser URL. In dev the Vite proxy serves /uploads, so the
 * path is used as-is; VITE_UPLOADS_URL can prefix an absolute CDN origin in prod.
 */
export function variantUrl(
  path: string,
  displayOrder: number,
  variant: 'thumbnail' | 'medium' | 'large',
): string {
  const prefix = path.endsWith('/') ? path : `${path}/`;
  return resolveUpload(`${prefix}${displayOrder}-${variant}.webp`);
}

/** Resolves a complete stored upload path (e.g. a banner's /uploads/banners/{id}.webp). */
export function uploadUrl(path: string): string {
  return resolveUpload(path);
}
